<template>
  <div class="badge-holder">
    <div :class="['badge', 'rbz-text-medium', classes, colorVariant]">
      {{ message }}
    </div>
  </div>
</template>

<script setup lang="ts">
export type MessageBadgeColor =
  | 'border-success'
  | 'full-success'
  | 'border-info'
  | 'full-info'
  | 'border-warning'
  | 'light-warning'
  | 'full-warning'
  | 'border-error'
  | 'light-error'
  | 'full-error'
  | 'manual-tag'
  | 'automatic-tag';

interface MessagesBadgeProps {
  message: string;
  classes?: string;
  colorVariant: MessageBadgeColor;
  disabled?: boolean;
}

withDefaults(defineProps<MessagesBadgeProps>(), {
  classes: '',
  disabled: false,
});
</script>

<style scoped lang="scss">
@use 'sass:map';
@use '../../assets/styles/colors' as colors;

.badge-holder {
  .badge {
    border-radius: 4px;
    padding: 4px 8px;
    width: fit-content;
  }

  .border-success {
    border: 1px solid map.get(colors.$colors, 'harlequin');
    color: map.get(colors.$colors, 'harlequin');
  }

  .full-success {
    background: map.get(colors.$colors, 'harlequin');
    border: 1px solid map.get(colors.$colors, 'harlequin');
    color: map.get(colors.$colors, 'white');
  }

  .border-info {
    border: 1px solid map.get(colors.$colors, 'fun-blue');
    color: map.get(colors.$colors, 'fun-blue');
  }

  .full-info {
    background: map.get(colors.$colors, 'fun-blue');
    border: 1px solid map.get(colors.$colors, 'fun-blue');
    color: map.get(colors.$colors, 'white');
  }

  .border-warning {
    border: 1px solid map.get(colors.$colors, 'amber');
    color: map.get(colors.$colors, 'amber');
  }

  .light-warning {
    background: map.get(colors.$colors, 'barley-white');
    border: 1px solid map.get(colors.$colors, 'barley-white');
    color: map.get(colors.$colors, 'anzac');
  }

  .full-warning {
    background: map.get(colors.$colors, 'amber');
    border: 1px solid map.get(colors.$colors, 'amber');
    color: map.get(colors.$colors, 'white');
  }

  .border-error {
    border: 1px solid map.get(colors.$colors, 'crimson');
    color: map.get(colors.$colors, 'crimson');
  }

  .light-error {
    background: map.get(colors.$colors, 'your-pink');
    border: 1px solid map.get(colors.$colors, 'your-pink');
    color: map.get(colors.$colors, 'crimson');
  }

  .full-error {
    background: map.get(colors.$colors, 'crimson');
    border: 1px solid map.get(colors.$colors, 'crimson');
    color: map.get(colors.$colors, 'white');
  }

  .manual-tag {
    border: 1px solid map.get(colors.$colors, 'daisy-bush');
    color: map.get(colors.$colors, 'daisy-bush');
  }

  .automatic-tag {
    border: 1px solid map.get(colors.$colors, 'fun-blue');
    color: map.get(colors.$colors, 'fun-blue');
  }
}
</style>
